import { useEffect, useState } from "react";
import { useQuery, useMutation } from "react-query";
import NavigasiAdmin from "../../components/NavigasiAdmin";
import { API } from "../../config/api";
import rupiahFormat from "rupiah-format";
import image from "../../assets/img/empty.svg";
import { Link, useNavigate } from "react-router-dom";
import DeleteData from "../../components/DeleteData";
import { Button } from "react-bootstrap";

function ListProduct() {
  document.title = "List Product";
  let navigate = useNavigate();

  const [query, setQuery] = useState("");

  // Variabel for delete product data
  const [idDelete, setIdDelete] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);

  // Modal Confirm delete data
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let { data: products, refetch } = useQuery("productsCache", async () => {
    const response = await API.get("/products");
    return response.data.data;
  });

  const handleUpdate = (id) => {
    navigate("/edit-product/" + id);
  };

  // For get id product & show modal confirm delete data
  const handleDelete = (id) => {
    setIdDelete(id);
    handleShow();
  };

  // Create function for handle delete product here ...
  // If confirm is true, execute delete data
  const deleteById = useMutation(async (id) => {
    try {
      await API.delete(`/product/${id}`);
      refetch();
    } catch (error) {
      console.log(error);
    }
  });
  // Call function for handle close modal and execute delete data with useEffect here ...
  useEffect(() => {
    if (confirmDelete) {
      // Close modal confirm delete data
      handleClose();
      // execute delete data by id function
      deleteById.mutate(idDelete);
      setConfirmDelete(null);
    }
  }, [confirmDelete]);

  return (
    <>
      <NavigasiAdmin active="product" />
      <div className="list-product-section container">
        <p className="fw-bold mt-5 mb-3">List Product</p>
        <div className="row d-flex justify-content-between">
          <div className="col-md-2">
            <Link to="/add-product" className="btn btn-dark w-100">
              Add
            </Link>
          </div>
          <div className="col-md-3">
            <input
              type="text"
              name="search"
              id="search"
              className="bg-dark text-white mb-3 form-control"
              placeholder="Search product name"
              onChange={(event) => setQuery(event.target.value)}
            />
          </div>
        </div>
        {products?.length !== 0 ? (
          <>
            <table
              className="table table-dark table-striped"
              style={{ fontFamily: "Arial" }}
            >
              <thead>
                <tr>
                  <th scope="col">No</th>
                  <th scope="col">Photo</th>
                  <th scope="col">Product Name</th>
                  <th scope="col">Product Desc</th>
                  <th scope="col">Price</th>
                  <th scope="col">Qty</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {products
                  ?.filter((data) => {
                    if (query === "") {
                      return data;
                    } else if (
                      data.name.toLowerCase().includes(query.toLowerCase())
                    ) {
                      return data;
                    }
                  })
                  .map((product, index) => (
                    <tr key={product.id}>
                      <th>{index + 1}</th>
                      <td>
                        <img
                          src={product.image}
                          alt="imageProduct"
                          className="img-fluid"
                          width={150}
                        />
                      </td>
                      <td>{product.name}</td>
                      <td>{product.desc.slice(0, 15) + "..."}</td>
                      <td>{rupiahFormat.convert(product.price)}</td>
                      <td>{product.qty}</td>
                      <td>
                        <div className="row">
                          <div className="col-md-6">
                            <button
                              className="btn btn-success w-100"
                              onClick={() => {
                                handleUpdate(product.id);
                              }}
                            >
                              Edit
                            </button>
                          </div>
                          <div className="col-md-6">
                            <Button
                              onClick={() => {
                                handleDelete(product.id);
                              }}
                              className="btn btn-danger w-100"
                            >
                              Delete
                            </Button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </>
        ) : (
          <>
            <div className="text-center pt-5">
              <img
                src={image}
                className="img-fluid my-5"
                style={{ width: "40%" }}
                alt="noData"
              />
              <div className="mt-3 mb-5">No data products</div>
            </div>
          </>
        )}
      </div>

      <DeleteData
        setConfirmDelete={setConfirmDelete}
        show={show}
        handleClose={handleClose}
      />
    </>
  );
}

export default ListProduct;
